export default __webpack_public_path__ + "static/media/calendar.63d8fdb6.png";